module.exports = __webpack_public_path__ + "img/rentpayer.5cd427e1.svg";